// extracted by mini-css-extract-plugin
export default {"icon":"MoreMenu-index__icon--sqaGg","dropdownButton":"MoreMenu-index__dropdownButton--OeLnt"};